/* PD collection page (2026-10-04): product cards, filter panel and scroll loading of sections/pd-collection,
   ported from the pdpaola theme's assets/pd.js. Styles in assets/pd-collection.css. */
(() => {
  if (window.__pdCollection) return;
  window.__pdCollection = true;
  const root = document.documentElement;

  /* ───────────── Photo strips: one photo per swipe, also by mouse drag (2026-09-24, explicit request: "deslizo en
     producto y no funciona bien"). Native scroll-snap stays for touch; a mouse (e.g. the theme editor's phone preview)
     drags the strip by hand, and every swipe settles on the next/previous photo. ───────────── */
  function swipeStrip(track) {
    if (!track || track.dataset.pdSwipe) return;
    track.dataset.pdSwipe = '1';
    const slideW = () => (track.firstElementChild ? track.firstElementChild.offsetWidth : track.clientWidth) || 1;
    const count = () => track.children.length;
    const goTo = (i) => track.scrollTo({ left: Math.max(0, Math.min(count() - 1, i)) * slideW(), behavior: 'smooth' });
    let startX = 0, startY = 0, startLeft = 0, startIdx = 0, dragging = false, moved = false, axis = '';
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || count() < 2) return;
      dragging = true; moved = false; axis = '';
      startX = e.clientX; startY = e.clientY; startLeft = track.scrollLeft; startIdx = Math.round(startLeft / slideW());
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX, dy = e.clientY - startY;
      if (!axis) { if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return; axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; }
      if (axis !== 'x') return;
      moved = true;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = startLeft - dx;
      e.preventDefault();
    }, { passive: false });
    window.addEventListener('pointerup', (e) => {
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      const dx = e.clientX - startX;
      const step = Math.abs(dx) > 40 ? (dx < 0 ? 1 : -1) : 0;
      track.style.scrollBehavior = '';
      goTo(startIdx + step);
      setTimeout(() => { track.style.scrollSnapType = ''; }, 450);
    });
    // a drag must not follow the link under the photo
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', (e) => e.preventDefault());
    // Touch: whatever the browser's own snapping does, once the finger is up and the strip stops, it lands on exactly
    // one photo — the next/previous one if the swipe went past 15% of a photo, else back where it started.
    let touching = false, touchIdx = 0, settleTimer = 0;
    track.addEventListener('touchstart', () => { touching = true; touchIdx = Math.round(track.scrollLeft / slideW()); clearTimeout(settleTimer); }, { passive: true });
    const settle = () => {
      if (touching || dragging) return;
      const w = slideW();
      const exact = track.scrollLeft / w;
      if (Math.abs(exact - Math.round(exact)) < 0.01) return;
      const delta = exact - touchIdx;
      const target = Math.abs(delta) > 0.15 ? touchIdx + Math.sign(delta) : touchIdx;
      goTo(target);
    };
    track.addEventListener('touchend', () => { touching = false; clearTimeout(settleTimer); settleTimer = setTimeout(settle, 160); }, { passive: true });
    track.addEventListener('touchcancel', () => { touching = false; }, { passive: true });
    track.addEventListener('scroll', () => { if (touching) return; clearTimeout(settleTimer); settleTimer = setTimeout(settle, 160); }, { passive: true });
    // the card photo sits inside a link: a link drag would cancel the pointer and stop the swipe
    const link = track.closest('a');
    if (link) { link.setAttribute('draggable', 'false'); link.addEventListener('dragstart', (e) => e.preventDefault()); }
    window.addEventListener('pointercancel', () => {
      if (!dragging) return;
      dragging = false;
      track.style.scrollBehavior = '';
      goTo(Math.round(track.scrollLeft / slideW()));
      setTimeout(() => { track.style.scrollSnapType = ''; }, 450);
    });
  }
  const initSwipes = () => document.querySelectorAll('[data-pd-gallery], [data-pd-track]').forEach(swipeStrip);

  /* ───────────── Product cards (snippets/pd-product-card) ───────────── */
  const canHover = window.matchMedia('(hover: hover) and (min-width: 960px)');
  const wishlist = () => { try { return JSON.parse(localStorage.getItem('liorme_wishlist')) || []; } catch (e) { return []; } };

  function initCards(scope) {
    const saved = wishlist();
    (scope || document).querySelectorAll('[data-pd-card]:not([data-pd-ready])').forEach((card) => {
      card.dataset.pdReady = '1';
      // product-wishlist.js paints the hearts on load; cards added later by the scroll loader are painted here
      card.querySelectorAll('[data-product-wishlist]').forEach((b) => { const on = saved.includes(b.dataset.handle); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      const track = card.querySelector('[data-pd-track]');
      const slides = track ? track.children.length : 0;
      const bar = card.querySelector('[data-pd-progress]');
      const index = () => (track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0);
      const go = (i, smooth = true) => track.scrollTo({ left: Math.max(0, Math.min(slides - 1, i)) * track.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
      if (track && slides > 1) {
        track.addEventListener('scroll', () => { if (bar) bar.style.transform = `translateX(${index() * 100}%)`; }, { passive: true });
        const prev = card.querySelector('[data-pd-prev]');
        const next = card.querySelector('[data-pd-next]');
        if (prev) prev.addEventListener('click', () => go(index() - 1 < 0 ? slides - 1 : index() - 1));
        if (next) next.addEventListener('click', () => go(index() + 1 >= slides ? 0 : index() + 1));
        // Desktop: the second photo shows on hover, back to the first on leave.
        const media = card.querySelector('.pd-pc__media');
        media.addEventListener('mouseenter', () => { if (canHover.matches && index() === 0) { go(1, false); card.dataset.pdHovered = '1'; } });
        media.addEventListener('mouseleave', () => { if (card.dataset.pdHovered) { delete card.dataset.pdHovered; go(0, false); } });
      }

      card.querySelectorAll('[data-pd-swatch]').forEach((sw) => sw.addEventListener('click', () => {
        card.querySelectorAll('[data-pd-swatch]').forEach((o) => { o.classList.toggle('is-selected', o === sw); o.setAttribute('aria-pressed', o === sw ? 'true' : 'false'); });
        card.querySelectorAll('[data-pd-card-link]').forEach((a) => { a.href = sw.dataset.url; });
        const price = card.querySelector('[data-pd-price]');
        if (price && sw.dataset.price) price.textContent = sw.dataset.price;
        card.querySelectorAll('[data-pd-add]').forEach((b) => { b.dataset.variantId = sw.dataset.variantId; b.disabled = sw.dataset.available !== 'true'; });
        if (track && sw.dataset.mediaId) {
          const i = [...track.children].findIndex((sl) => sl.dataset.mediaId === sw.dataset.mediaId);
          if (i > -1) { delete card.dataset.pdHovered; go(i); }
        }
      }));

      card.querySelectorAll('[data-pd-add]').forEach((btn) => btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.classList.contains('is-busy')) return;
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const label = btn.textContent;
        btn.classList.add('is-busy');
        fetch(`${base}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }) })
          .then((r) => { if (!r.ok) throw r; return fetch(`${base}cart.js`); })
          .then((r) => r.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            // theme.js opens the quick cart on this event (hook added for the gucci-style product page)
            if (window.gcQuickCart) document.dispatchEvent(new CustomEvent('gc:cart-added', { detail: { cart } }));
            else if (label.trim()) { btn.textContent = 'Añadido'; setTimeout(() => { btn.textContent = label; }, 1600); }
          })
          .catch(() => { window.location.href = card.querySelector('[data-pd-card-link]').href; })
          .finally(() => btn.classList.remove('is-busy'));
      }));
    });
  }

  /* ───────────── Collection page (sections/pd-collection): filters panel + more products on scroll ───────────── */
  function initCollection() {
    document.querySelectorAll('[data-pd-collection]:not([data-pd-ready])').forEach((col) => {
      col.dataset.pdReady = '1';
      const panel = col.querySelector('[data-pd-filter]');
      const openBtn = col.querySelector('[data-pd-filter-open]');
      if (panel && openBtn) {
        // Out of the section so no transformed ancestor can clip the fixed panel.
        const old = document.getElementById(panel.id);
        if (old && old !== panel && !col.contains(old)) old.remove();
        document.body.appendChild(panel);
        const open = () => { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); openBtn.setAttribute('aria-expanded', 'true'); root.classList.add('pd-lock'); };
        const close = () => { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); openBtn.setAttribute('aria-expanded', 'false'); root.classList.remove('pd-lock'); openBtn.focus({ preventScroll: true }); };
        openBtn.addEventListener('click', open);
        panel.addEventListener('click', (e) => { if (e.target.closest('[data-pd-filter-close]')) close(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
        // Empty price boxes would send "filter.v.price.gte=" — drop them.
        const form = panel.querySelector('form');
        if (form) form.addEventListener('submit', () => form.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; }));
      }

      // "Leer más" / "Leer menos" under the title
      col.addEventListener('click', (e) => {
        const t = e.target.closest('[data-pd-desc-toggle]');
        if (!t) return;
        e.preventDefault();
        const short = col.querySelector('[data-pd-desc-short]');
        const full = col.querySelector('[data-pd-desc-full]');
        if (!short || !full) return;
        const showFull = full.hidden;
        full.hidden = !showFull;
        short.hidden = showFull;
      });

      // Active category stays in view in the scrolling row (phones).
      const active = col.querySelector('.pd-col__nav a.is-active');
      const nav = col.querySelector('.pd-col__nav');
      if (active && nav && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = Math.max(0, active.offsetLeft - 15);

      const grid = col.querySelector('[data-pd-grid]');
      let more = col.querySelector('[data-pd-more]');
      if (!grid || !more) return;
      let loading = false;
      let io = null;
      const observe = () => {
        if (io) io.disconnect();
        if (!more || !('IntersectionObserver' in window)) return;
        io = new IntersectionObserver((entries) => { if (entries.some((en) => en.isIntersecting)) load(); }, { rootMargin: '800px 0px' });
        io.observe(more);
      };
      function load() {
        const link = more && more.querySelector('[data-pd-next-url]');
        if (loading || !link) return;
        loading = true;
        more.classList.add('is-loading');
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('section_id', col.dataset.sectionId);
        fetch(url.toString())
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            // cards and the editorial items between them
            doc.querySelectorAll('[data-pd-grid] > *').forEach((c) => grid.appendChild(document.importNode(c, true)));
            initCamps();
            initCards(grid);
            initSwipes();
            const nextMore = doc.querySelector('[data-pd-more]');
            if (nextMore) { more.replaceWith(document.importNode(nextMore, true)); more = col.querySelector('[data-pd-more]'); observe(); }
            else { more.remove(); more = null; if (io) io.disconnect(); }
          })
          .catch(() => { window.location.href = link.href; })
          .finally(() => { loading = false; if (more) more.classList.remove('is-loading'); });
      }
      col.addEventListener('click', (e) => { if (e.target.closest('[data-pd-next-url]')) { e.preventDefault(); load(); } });
      observe();
    });
  }


  /* Campaign bands: two or three photos cross-fade */
  function initCamps() {
    document.querySelectorAll('[data-pd-camp]:not([data-pd-ready])').forEach((camp) => {
      camp.dataset.pdReady = '1';
      const imgs = camp.querySelectorAll('.pd-camp__img');
      if (imgs.length < 2) return;
      let i = 0;
      setInterval(() => {
        if (!camp.isConnected) return;
        imgs[i].classList.remove('is-active');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-active');
      }, 3500);
    });
  }

  const init = () => { initCards(); initCollection(); initSwipes(); initCamps(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  // other collection sections that bring in more cards (assets/pr-collection.js) ask for them to be set up
  document.addEventListener('pd:refresh', init);
})();
